import { render, staticRenderFns } from "./LabelCornersIcon.vue?vue&type=template&id=6ddefe76&"
import script from "./LabelCornersIcon.vue?vue&type=script&lang=js&"
export * from "./LabelCornersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports